<template>
  <q-btn-dropdown icon="fa fa-user" rounded flat>
    <div class="text-subtitle2 q-pa-md bg-grey-1">
      <strong>{{ appUser.account.name }}</strong><br>
    </div>
    <q-separator />
    <div class="row no-wrap q-pa-md">
      <div class="column justify-center items-center">
        <q-icon name="fa fa-user-circle" size="md" />
        <div class="q-mt-md">
          {{ displayName }}
        </div>
      </div>
      <q-separator vertical inset class="q-mx-lg" />
      <div class="column items-center">
        <change-password-btn :user-id="appUser.id" icon="fa fa-lock" flat />
        <logout-btn icon="fa fa-sign-out-alt" flat class="q-mt-sm" />
      </div>
    </div>
  </q-btn-dropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { AppUser } from '@/type';
import ChangePasswordBtn from '@/user/ChangePasswordBtn.vue';
import recognition from './recognition';
import LogoutBtn from './LogoutBtn.vue';

interface Data {
  appUser: AppUser|null
}

export default defineComponent({
  components: { LogoutBtn, ChangePasswordBtn },
  data(): Data {
    return {
      appUser: recognition.getAppUser(),
    };
  },
  computed: {
    displayName(): string|null {
      if (this.appUser === null) return null;
      if (this.appUser.firstName !== undefined && this.appUser.lastName !== undefined) {
        return `${this.appUser.firstName} ${this.appUser.lastName}`;
      }
      return this.appUser.displayName;
    },
  },
});
</script>
